import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { CashinButton } from '@/cashins/views/CashinButton';
import GearWheelIcon from 'nike-ui/src/icons/svg/gear-wheel-icon-sv.svg';
import PopupNg from '@/ui/PopupNg';
import clsx from 'clsx';
import { useIsChannelStatusDelayed } from 'nike-ui/src/components/ticketus/cashin/useIsChannelStatusDelayed';
import { useCashinButton } from 'nike-ui/src/components/ticketus/cashin/useCashinHooks';
import CashinPositionContext from 'nike-ui/src/common/CashinPositionContext';

function Cashin({ ticketId }) {
    const { hidden, disabled, cashinOffer, autoCashinDisabled } = useCashinButton(ticketId);
    if (hidden) {
        return null;
    }
    return (
        <div className="ticket-cashin">
            <CashinButton
                detailInfo={false}
                cashinOffer={cashinOffer}
                trackAction="Odkup z detailu tiketu"
                disabled={disabled}
            />
            <AutoCashinButton cashinOffer={cashinOffer} disabled={disabled || autoCashinDisabled} />
        </div>
    );
}

function AutoCashinButton({ cashinOffer, disabled }) {
    const ticketId = cashinOffer.ticketId;
    const { cashinPosition } = useContext(CashinPositionContext);

    function openAutoCashinDialog() {
        PopupNg.dispatcher.open('cashin/auto-cashin-dialog', { ticketId, cashinPosition }, 2);
    }

    const isChannelStatusDelayed = useIsChannelStatusDelayed(cashinOffer);
    return cashinOffer.automaticTransactionAllowed && !isChannelStatusDelayed ? (
        <button
            onClick={openAutoCashinDialog}
            className={clsx('ticket-cashin-options-button', { disabled })}
            disabled={disabled}
        >
            <div className={clsx({ 'item-badge': cashinOffer.automaticTransactionLimit })} data-badge={'A'}>
                <GearWheelIcon />
            </div>
        </button>
    ) : null;
}

Cashin.propTypes = {
    ticketId: PropTypes.string.isRequired,

    cashinPosition: PropTypes.string
};

export default Cashin;
